module.exports = __webpack_public_path__ + "img/1.80bff129.svg";